import { parseAssistantResponse } from './aiResponseParser';
/** Provider yanıtı gelir gelmez parse, action execution ve debug snapshot üretir. */
export async function processAiProviderResponse(response, options) {
    const parsed = parseAssistantResponse(response.content);
    const executionResults = await options.executeActions(parsed);
    let debug;
    if (options.captureDebug) {
        debug = {
            jobs: parsed.jobs,
            actions: parsed.actions,
            payloads: parsed.payloads,
            executionResults,
            receivedAt: new Date().toISOString(),
        };
        console.debug('[aiChat] provider response', {
            messageId: response.id,
            conversationId: response.conversationId,
            contentLength: response.content.length,
            structured: {
                jobs: parsed.jobs.length,
                actions: parsed.actions.length,
                payloads: parsed.payloads.length,
            },
            executionResults,
            jobs: parsed.jobs,
            actions: parsed.actions,
            payloads: parsed.payloads,
        });
    }
    return {
        id: response.id,
        role: 'assistant',
        content: response.content,
        timestamp: new Date(response.timestamp),
        debug,
    };
}
